/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useTableData } from '../AI FMS Summary  Dyanmic/hooks/useTableData';
import VariantTable from '../Food Products/VariantPrice/VariantTable';
import { Info } from 'lucide-react';
import { TAB_BUTTON_ACTIVE, TAB_BUTTON_BASE, TAB_BUTTON_INACTIVE } from './productionAnalysisHelper';
import aiPackaging from '@/Services/aiPackaging.services';
import notificationServices from '@/Services/notification.services';
import { BackdropLoader } from '@/Components/Loaders';
import { checkNull } from '@/Helpers';
import moment from 'moment';
import StatsComp from './StatsComp';
import DateRangePickerRsuit from '@/Components/DateRangePickerRsuit/DateRangePickerRsuit';
import { useAiFmsData } from '../AI FMS Summary  Dyanmic/hooks/useAiFmsData';
import { useAuth } from '@/Components/Auth/Login/auth';


const chartTabs = [
    {
        value: 'weight',
        label: 'Total Weight',
    },
    {
        value: 'cost',
        label: 'Total Cost',
    },
    {
        value: 'count',
        label: 'Total Count',
    },
]

const ProductionDetailsModalContent = ({ rawData, id, name, dateRange, filters, initialTab, type, initialStats }) => {
    const { appConfig = {} } = useAuth();
    const [data, setData] = useState(rawData);
    const [loading, setLoading] = useState(false);
    const { getTableInfo } = useTableData(data, undefined, '', false);
    const [selectedChartTab, setSelectedChartTab] = useState(initialTab || chartTabs[0].value);
    const [statsDateRange, setStatsDateRange] = useState(dateRange);
    const tableInfo = getTableInfo();

    const { statsSummary, fetchCogsAnalysisGraph } = useAiFmsData({
        parentTab: { value: 'PRODUCED' },
    });

    useEffect(() => {
        if (statsDateRange?.from && statsDateRange?.to) {
            const getSelectedTab = selectedChartTab === 'weight' ? 'TotalWeight' : selectedChartTab === 'cost' ? 'TotalCost' : 'TotalCount';
            const extraFilters = {
                producedVariantIds: type === 'product' ? [id] : [],
                processIds: type === 'process' ? [id] : filters?.processIds,
            };
            fetchCogsAnalysisGraph(statsDateRange, filters?.type ? checkNull(filters?.type) : null, getSelectedTab, 'produced', false, extraFilters);
        }
    }, []);

    const displayedStats = statsSummary?.length > 0 ? statsSummary : initialStats;

    const Legend = () => (
        <div className="flex items-center gap-2 mb-3 p-2.5 px-4 bg-teal-50 border border-teal-100 rounded-lg text-teal-800 text-[12.5px] font-medium shadow-sm">
            <Info size={16} className="text-teal-600 shrink-0" />
            <p>
                <span className="font-bold">Pro Tip:</span> Click on a <span className="text-blue-700 font-bold underline">Product Name</span> to explore its in-depth statistical analysis and historical production trends.
            </p>
        </div>
    );

    const fetchDetails = async (format, range = statsDateRange) => {
        const req = {
            data: {
                dateRangeFilter: {
                    from: moment(range?.from).format('YYYY-MM-DD'),
                    to: moment(range?.to).format('YYYY-MM-DD'),
                },
                selectedTab: 'produced',
                selectedSubTab: 'processwise',
                selectedDataFormat: format,
                producedVariantIds: type === 'product' ? [id] : [],
                NO_CACHE: true,
                shiftId: filters?.type ? checkNull(filters?.type) : null,
                processIds: type === 'process' ? [id] : filters?.processIds,
                summaryDateGrouping: true,
            },
        }

        setLoading(true);
        try {
            const response = await aiPackaging?.fetchFmsAnalyticsGrid(req);
            if (response?.statusCode === 200) {
                setData(response.data);
            } else {
                notificationServices.generateNotification({
                    type: 'error',
                    message: response?.message || 'Error fetching production details',
                });
            }
        } catch (error) {
            notificationServices.generateNotification({
                type: 'error',
                message: error?.message || 'Error fetching production details',
            });
        } finally {
            setLoading(false);
        }
    }

    const handleChartTabChange = (tab) => {
        if (tab === selectedChartTab) return;
        setSelectedChartTab(tab);
        fetchDetails(tab, statsDateRange);
    }

    return (
        <div className="h-full flex flex-col p-4 pt-1 relative">
            <BackdropLoader isLoading={loading} />
            <Legend />
            <div className='mb-4 flex w-full items-center justify-between gap-4'>
                <div className='inline-flex rounded-xl gap-2 p-1'>
                    {chartTabs?.map((tab) => {
                        const isActive = selectedChartTab === tab.value;
                        return (
                            <button
                                key={tab.value}
                                onClick={() => handleChartTabChange(tab.value)}
                                className={`${TAB_BUTTON_BASE} ${isActive
                                    ? TAB_BUTTON_ACTIVE
                                    : TAB_BUTTON_INACTIVE
                                    }`}
                                disabled={tab.disabled || loading}
                            >
                                {tab.label}
                            </button>
                        );
                    })}
                </div>
                <div className="flex items-center gap-3">
                    <span className="text-sm font-semibold text-gray-600">Stats Date Range:</span>
                    <DateRangePickerRsuit
                        dateRanges={[{
                            startDate: statsDateRange?.from || new Date(),
                            endDate: statsDateRange?.to || new Date(),
                            key: 'selection'
                        }]}
                        onDateRangeChange={(rangeInfo) => {
                            if (rangeInfo?.selection) {
                                setStatsDateRange({
                                    from: rangeInfo.selection.startDate,
                                    to: rangeInfo.selection.endDate
                                });
                                const getSelectedTab = selectedChartTab === 'weight' ? 'TotalWeight' : selectedChartTab === 'cost' ? 'TotalCost' : 'TotalCount';
                                fetchCogsAnalysisGraph(statsDateRange, filters?.type ? checkNull(filters?.type) : null, getSelectedTab, 'produced', false, {
                                    producedVariantIds: type === 'product' ? [id] : [],
                                    processIds: type === 'process' ? [id] : filters?.processIds,
                                });
                                fetchDetails(selectedChartTab, statsDateRange);
                            }
                        }}
                        width={250}
                    />
                </div>
            </div>
            <StatsComp statsCards={displayedStats?.map((ele) => ({
                ...ele,
                value: ele?.amount,
            }))} />
            <div className="h-[calc(100vh-450px)] border rounded-xl shadow-sm">
                <VariantTable
                    data={tableInfo.data}
                    columns={tableInfo.tableColumns}
                    customRowData={tableInfo.tableRows}
                    customCol={tableInfo.customCol}
                    sortValueInfo={tableInfo.sortInfo}
                    isLoading={false}
                />
            </div>
        </div>
    );
};

export default ProductionDetailsModalContent;
